import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { NavLink, withRouter } from "react-router-dom";
import { Sidebar, Menu } from "semantic-ui-react";
import * as AppActions from "../../actions";
import _ from "lodash";

class SideBar extends Component {
  renderLogo() {
    const { storeLogo } = this.props;

    let logoSet = storeLogo;

    return (
      <div style={{ backgroundColor: "#ffffff", width: "100%" }}>
        <img style={{ height: "46px" }} src={logoSet} />
      </div>
    );
  }

  hideMenu() {
    this.props.actions.setSidebarVisibility(false);
  }

  render() {
    const { sidebarVisibility, storeId, test } = this.props;

    let element = _.filter(this.props.actionQueue, function(q) {
      return q.draftName !== "" && q.storeId === storeId && q.test === test;
    });

    var draftCount = element.length;
    var formCount = _.filter(this.props.actionQueue, {
      storeId: storeId,
      isDraft: false,
      test: test
    }).length;

    return (
      <Sidebar
        style={{ backgroundColor: "#ffffff" }}
        as={Menu}
        animation="uncover"
        width="thin"
        visible={sidebarVisibility}
        icon="labeled"
        vertical
        inverted
      >
        {this.renderLogo()}
        <Menu.Item name="forms">
          <NavLink
            className="NavLink"
            onClick={this.hideMenu.bind(this)}
            to="/forms"
          >
            FORMS
          </NavLink>
        </Menu.Item>
        <Menu.Item name="settings">
          <NavLink
            className="NavLink"
            onClick={this.hideMenu.bind(this)}
            to="/settings"
          >
            SETTINGS
          </NavLink>
        </Menu.Item>
        <Menu.Item name="outbox">
          <NavLink
            className="NavLink"
            onClick={this.hideMenu.bind(this)}
            to="/outbox"
          >
            {"OUTBOX(" + formCount + ")"}
          </NavLink>
        </Menu.Item>
        <Menu.Item name="drafts">
          <NavLink
            className="NavLink"
            onClick={this.hideMenu.bind(this)}
            to="/drafts"
          >
            {"DRAFTS(" + draftCount + ")"}
          </NavLink>
        </Menu.Item>
        <Menu.Item name="approvals">
          <NavLink
            className="NavLink"
            onClick={this.hideMenu.bind(this)}
            to="/approvals"
          >
            APPROVALS
          </NavLink>
        </Menu.Item>
        <Menu.Item name="sent">
          <NavLink
            className="NavLink"
            onClick={this.hideMenu.bind(this)}
            to="/sent"
          >
            SENT
          </NavLink>
        </Menu.Item>
        <Menu.Item name="tasks">
          <NavLink
            className="NavLink"
            onClick={this.hideMenu.bind(this)}
            to="/tasks"
          >
            TASKS
          </NavLink>
        </Menu.Item>
        <Menu.Item name="logout">
          <NavLink
            className="NavLink"
            onClick={this.hideMenu.bind(this)}
            to="/logout"
          >
            LOGOUT
          </NavLink>
        </Menu.Item>
      </Sidebar>
    );
  }
}

SideBar.propTypes = {
  sidebarVisibility: PropTypes.bool.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  storeLogo: PropTypes.string.isRequired,
  storeColour: PropTypes.string.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  sidebarVisibility: state.informedWebApp.sidebarVisibility,
  storeLogo: state.informedWebApp.storeLogo,
  actionQueue: state.informedWebApp.actionQueue,
  test:
    state.informedWebApp.api === "https://www.in-formed.co.uk/api.php"
      ? false
      : true,
  storeId: state.informedWebApp.storeId,
  storeColour: state.informedWebApp.storeColour,
  isLoggedIn:
    state.informedWebApp.sessionId !== "" &&
    state.informedWebApp.authenticated === true
      ? true
      : false
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SideBar)
);



// WEBPACK FOOTER //
// ./src/components/SideBar/index.js